import { FC } from "react";
import { IPageAction } from "../../../base/models";
import { MUIIcon } from "../../../widgets";
import clsx from "clsx";
import { useGetTouUrl } from "../services/useTouUrl";

interface IActionTOULinkProps {
    action: IPageAction
    className?: string
}

export const ActionTOULink: FC<IActionTOULinkProps> = ({
    action, className
}) => {
    const { touUrl } = useGetTouUrl()

    if (!touUrl)
        return <button
            type="button"
            className={className}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            {action.name}
        </button>

    return (
        <a
            className={clsx(className, "btn btn-secondary btn-sm")}
            href={touUrl}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            <span>{action.name}</span>
        </a>
    )
}
